module.exports = __webpack_public_path__ + "img/xn.0e95a51c.png";